import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { UserProfilePasswordReset } from '../../models/user-profile-password-reset'
import { UserProfile } from '../../models/user-profile'
import { CurrentUser } from '../../../common/models/current-user'
import { UserProfileGateway } from '../../gateways/user-profile-gateway'
import { Router, ActivatedRoute } from '@angular/router'
import { SecurityQuestion } from '../../models/security-question-model'
import { Location } from '@angular/common'
import { UserDataService } from '../../gateways/user-data-service'
import { FormValidationService } from '../../../validations/form-validation-service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { PasswordCorrectValidator } from '../../../validations/password-correct-validator'
import { UpdatePasswordComponent } from '../../components/update-password/update-password.component'



import { EmailAddressTextFieldValidator } from '../../../validations/email-address-text-field-validator'
import { PhoneNumberInputMask } from '../../../common/input-masks/phone-number.input-mask'

import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'Change_Email',
    templateUrl: 'update-email.component.html'
})

export class UpdateEmailComponent implements OnInit {

    emailValidator = new EmailAddressTextFieldValidator()
    oldPasswordErrorMsg: string
    errorConfMsg: string
    userProfileID: number
    userProfileName: string
    userEmail: string
    userConfirmEmail: string
    CloseBtnText: string
    userProfileModel: UserProfile
    type: string = 'password'
    ErrorMessages: any[]
    errorlist: any[]
    errorlists: any[]
    isFormValid: boolean
    isChangeCellPhoneNumber: number
    showSuccessMsg: boolean
    insCo: string 
    questionOptions: ValidatedSelectOptionModel[] = []
    notBlankValidator = new NotBlankGenericFieldValidator()
    passwordCorrectValidator: PasswordCorrectValidator
    updatePasswordComponent: UpdatePasswordComponent

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef;

    constructor(private routers: Router, private route: ActivatedRoute, private _networkUserAccessGateway: UserAccessGateway,private portalglobals: PortalGlobals,
        private userProfileGateway: UserProfileGateway, private _location: Location,
        private formValidationService: FormValidationService,
        private userdataservice: UserDataService) {
        this.userProfileModel = {} as UserProfile
        this.route.params.subscribe(params => {
            if (params['userprofileid']) {
                this.userProfileID = params['userprofileid']
                this.passwordCorrectValidator = new PasswordCorrectValidator(this.userProfileGateway, this.userProfileID)
                this.isChangeCellPhoneNumber = Number(params['isChangeCellPhoneNumber'])
            }
            if (params['insCo']) {
                this.insCo = params['insCo']
            }


        })
        // this.updatePasswordComponent = new UpdatePasswordComponent();
    }
    ngOnInit() {
        this.showSuccessMsg = false
        this.isFormValid = true
        this.userProfileGateway.findUserProfileByProfileID(this.userProfileID).subscribe(
            (model: UserProfile) => {
                if (model !== undefined && model !== null) {
                    this.userProfileModel = model
                    this.userProfileName = model.UserProfileName
                }
            })

    }


    private validateForm() {
        this.ErrorMessages = []
        this.isFormValid = true
        // if (this.userEmail === '') {
        if (this.userEmail === undefined || this.userEmail === null || this.userEmail === '') {
            this.isFormValid = false
            this.ErrorMessages.push('Please enter Email')
        }
        // if (this.userConfirmEmail === '') {
        if (this.userConfirmEmail === undefined || this.userConfirmEmail === null || this.userConfirmEmail === '') {
            this.isFormValid = false
            this.ErrorMessages.push('Please enter ConfirmEmail')
        }
        if (!(this.userConfirmEmail === this.userEmail)) {
            this.isFormValid = false
            this.ErrorMessages.push('Both Email and ConfirmEmail should match')
        }
        let isUserEmailValid = this.isValidEmail(this.userEmail)
        if (!isUserEmailValid) {
            this.isFormValid = false
            this.ErrorMessages.push('Email Address is invalid')
        }
    }

    Save() {
        this.validateForm()
        if (this.isFormValid === true) {

            this.userProfileGateway.updateEmail(this.userEmail, this.userProfileID).subscribe(
                (model: Boolean) => {
                    if (model.valueOf() === true) {
                        this.isFormValid = true
                        this.showSuccessMsg = true
                        this.errorConfMsg = 'You have successfully changed the email.'
                        this.redirectnextPage()
                    } else {
                        this.errorConfMsg = 'Something went wrong, please try again.'
                    }
                    this.focusableEleTop.nativeElement.focus()
                },
                (error) => {
                    this.errorlist = JSON.parse(error.statusText)
                    this.errorlists = this.errorlist.toString().split(',')
                    this.ErrorMessages = this.errorlists
                    this.isFormValid = false
                    this.focusableEleTop.nativeElement.focus()
                }
            )

        }
        else {
            this.focusableEleTop.nativeElement.focus()
        }

    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    private redirectnextPage() {
        this._networkUserAccessGateway.getCurrentUser()
            .subscribe(user => {
                if (user != null) {
                    console.log("user AGAUTH: " + user.BgAuthorized)
                    if (this.isChangeCellPhoneNumber == 1) {

                        let url = '/' + user.insuranceCompanyShortName.toLowerCase() + '/user-management/ChangeCellPhoneNo/' + user.userProfileId //+ '/' + user.insuranceCompanyShortName.toLowerCase()
                        this.routers.navigateByUrl(url)
                    } 
                    else if (localStorage.getItem('showlicense') === null || localStorage.getItem('showlicense') === 'null') {

                        let url = '/' + user.insuranceCompanyShortName.toLowerCase() +  '/user-management/licenselogin/' + user.userProfileId
                        this.routers.navigateByUrl(url)
                    }
                    else {
                        this.routers.navigate(['/' + user.insuranceCompanyShortName.toLowerCase() + '/home'])
                    }




                } else {
                    this.goToLogin()
                }
            },
                error => {

                    this.goToLogin()
                })
    }
    goToLogin() {
        window.location.href = '/Auth/Login.aspx?insCo=' + this.insCo 
    }
}
